import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import * as R from "ramda";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { read } from "Helpers/LocalStorage";
import {
  addStuffFitting,
  getAxFitting,
  getColorFitting,
  getDirectionFitting,
} from "Stores/actions";
import { useTranslation } from "react-i18next";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

function NewStuff({ selectedBrand }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({
    name: false,
    standardCode: false,
  });
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    standardCode: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    stuffAx: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null
    },
    stuffSide: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null
    },
    stuffColor: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null
    },
  });

  useEffect(() => {
    onClear();
    (async () => {
      setLoading(true);
      const axfitting = await dispatch(getAxFitting());
      const directionFitting = await dispatch(getDirectionFitting());
      const colorFitting = await dispatch(getColorFitting());
      setControls({ stuffAx: { selectItems: axfitting, value: axfitting[0] } });
      setControls({
        stuffSide: {
          selectItems: directionFitting,
          value: directionFitting[0],
        },
      });
      setControls({
        stuffColor: { selectItems: colorFitting, value: colorFitting[0] },
      });
      setLoading(false);
    })();
  }, []);

  const onClear = () => {
    setCheckValid(false);
    setFormValid({ name: false, standardCode: false });
    setControls({ name: { value: "" } });
    setControls({ standardCode: { value: "" } });
  };

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { name, standardCode, stuffAx, stuffSide, stuffColor } = controls;
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          idBrandFitting: selectedBrand.Id,
          idSdirection: stuffSide.value.value,
          idSlevelSecurity: 0,
          ax: stuffAx.value.value,
          idColorFitting: stuffColor.value.value,
          name: name.value,
          code: standardCode.value,
        };
        await dispatch(addStuffFitting(data));
        setLoading(false);
      } catch (e) {
        console.log("new stuff", e);
        setLoading(false);
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  return (
    <Grid container spacing={2} className="mb-4">
      <Grid
        item
        xs={12}
        className="text-center py-2 mb-3"
        style={{ backgroundColor: "#E4E8E8" }}
      >
        <strong>{`${t("newStuff")} ${selectedBrand.Name}`}</strong>
      </Grid>
      {!loading ? (
        <Grid container spacing={2}>
          {Object.keys(controls).map((key, index) => {
            return (
              <>
                {controls[key].type === "select" && (
                  <Grid item key={key + index} md={2} sm={4} xs={12}>
                    <MuiAutoComplete
                      loading={loading}
                      options={controls[key].selectItems}
                      label={<Translator id={key} />}
                      value={controls[key].value}
                      id={key}
                      onChange={autoCompleteHandler}
                      // helperText={checkValid && !formValid[key]}
                    />
                  </Grid>
                )}
                {controls[key].type === "text" && (
                  <Grid item key={key + index} md={2} sm={6} xs={12}>
                    <Input
                      setValue={setValue.bind(this)}
                      name={key}
                      placeholder={t(key)}
                      validation={controls[key].validation}
                      label={<Translator id={key} />}
                      type="text"
                      checkValid={checkValid && !formValid[key]}
                      value={controls[key].value}
                    />
                  </Grid>
                )}
              </>
            );
          })}
          <Grid
            item
            md={2}
            xs={12}
            className="d-flex justify-content-end align-items-center"
          >
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="ezafe_be_list" />}
              onClick={onFinish}
              fullwidthOnSm
              disabled={read("ShisheRules").accessRegister === false || !Object.keys(formValid).every((item) => formValid[item] === true)}
            />
          </Grid>
        </Grid>
      ) : (
        <div className="w-100 d-flex justify-content-center">
          <InnerCircularProgress />
        </div>
      )}
    </Grid>
  );
}

export default NewStuff;
